import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-frequent-questions',
  templateUrl: './frequent-questions.component.html',
  styleUrls: ['./frequent-questions.component.sass']
})
export class FrequentQuestionsComponent implements OnInit {
  public expand=[];
  public tabActive='Soporte';
  constructor(private global:GlobalService,public AngularFireAnalytics:AngularFireAnalytics) { 
    this.AngularFireAnalytics.setCurrentScreen("Soporte");
    this.AngularFireAnalytics.logEvent("Soporte");
  }

  ngOnInit() {
    if(this.global.validateSession()==true){
      this.expand[0]=true;
    }
  }
  updateExpand(index){
    this.global.validateSession();
    this.expand[index] = !this.expand[index];
  }
}